import { PaymentLineItem } from "@cruisen/contract"
import styles from "./styles.module.scss"
import { formatCurrency } from "@cruisen/i18n"
import { QuoteCard } from "../QuoteCard"

export const PaymentSummaryCard = ({ lineItem }: { lineItem: PaymentLineItem }) => {
  const areTaxesAndFeesIncluded = lineItem.taxesAndFees && Number(lineItem.taxesAndFees) > 0

  return (
    <QuoteCard title="Payment summary">
      <div className={styles.content}>
        <div className={styles.priceBlock}>
          <div className={styles.row}>
            <p>Cabin price</p>
            <p>{formatCurrency(Number(lineItem.amount), 2)}</p>
          </div>
          {areTaxesAndFeesIncluded ? (
            <div className={styles.row}>
              <p>Taxes and fees</p>
              <p>{formatCurrency(Number(lineItem.taxesAndFees || 0), 2)}</p>
            </div>
          ) : null}
          <div className={styles.divider} />
          <div className={`${styles.row} ${styles.total}`}>
            <p>Total amount</p>
            <p>{formatCurrency(Number(lineItem.total), 2)}</p>
          </div>
        </div>
        {lineItem?.deposit || lineItem?.totalDueDate ? (
          <div className={styles.priceBlock}>
            {lineItem?.deposit && (
              <div className={styles.row}>
                <p>Deposit amount</p>
                <p>{formatCurrency(Number(lineItem.deposit), 2)}</p>
              </div>
            )}
            {lineItem?.totalDueDate && (
              <div className={styles.row}>
                <p>Total due date</p>
                <p>{new Date(lineItem.totalDueDate).toLocaleDateString()}</p>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </QuoteCard>
  )
}
